import axios from 'axios';
import { getAccessToken } from '../auth/session';

const API_URL = 'https://d120ovw29hasnn.cloudfront.net/user';

const apiRequest = async (endpoint, method = 'GET', body = null) => {
  const send = async (forceRefresh) => {
    const token = await getAccessToken({ forceRefresh });
    if (!token) throw new Error('Not authenticated');
    return axios({
      method,
      url: `${API_URL}${endpoint}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: body,
    });
  };

  try {
    const response = await send(false);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      const retry = await send(true);
      return retry.data;
    }
    console.error('API Error:', error.response?.data || error.message);
    throw error;
  }
};

const paymentHandler = {
  async createCheckoutSession(email, priceId, isSubscription = true) {
    return apiRequest('/create-checkout-session', 'POST', { email, priceId, isSubscription });
  },

  async upgradeSubscription(email, newPriceId) {
    return apiRequest('/upgrade-subscription', 'POST', { email, newPriceId });
  },

  async downgradeSubscription(email, newPriceId) {
    return apiRequest('/downgrade-subscription', 'POST', { email, newPriceId });
  },

  async cancelDowngrade(email) {
    return apiRequest('/cancel-downgrade', 'POST', { email });
  },
};

export default paymentHandler;
